
function RTEcolorFixUl() {
  $('.ce-bodytext ul li span[style*="color:"]').each(function(i, e) {
    var elementsColor = $(this).css('color');
    $(this).parent('li').css({
      'color' : elementsColor
    })
  })
}

function RTEcolorFixOl() {
  $('.ce-bodytext ol li span[style*="color:"]').each(function(i,e) {
    var elementsColor = $(this).css('color');
    $(this).parent('li').css({
      'color' : elementsColor
    })
  })
}

$(document).ready(function() {
  if($('.ce-bodytext ul li span[style*="color:"]').length != 0) {
    RTEcolorFixUl();
  }

  if($('.ce-bodytext ol li span[style*="color:"]').length != 0) {
    RTEcolorFixOl();
  }
});
